module.exports = __webpack_public_path__ + "img/nunoTirapicos.25aaf0b7.webp";